import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/mutations',
    name: 'AdminMutations',
    meta: {
      resource: 'mutation',
    },
    component: {
      // render a single router-view to display child routes inside. Can also be a layout. Enables route-based breadcrumbs.
      name: 'AdminMutations',
      render(h) {
        return h('router-view');
      },
    },
    get redirect() {
      return this.children[0]; // make sure first child is always the empty path match aka Default child.
    },
    children: [
      {
        path: '',
        name: 'AdminMutationIndex',
        component: () => import('../views/MutationIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminMutationShow',
        component: () => import('../views/MutationShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminMutationIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminMutationDetails',
            component: () => import('../views/MutationDetails.vue'),
            meta: {
              backRoute: { name: 'AdminMutationIndex' },
            },
          },
          {
            path: 'connectorExports',
            name: 'AdminMutationConnectorExports',
            component: () => import('../views/MutationConnectorExports.vue'),
            meta: {
              resource: 'connector_export',
              backRoute: { name: 'AdminMutationIndex' },
            },
          },
        ],
      },
      {
        path: 'new',
        name: 'AdminMutationNew',
        component: () => import('../views/MutationInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminMutationIndex' },
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));